
export const RoadLocalStoreKey = 'roadSearchData';
export const FlightLocalStoreKey = 'flightSearchData';
